import * as Papa from "papaparse";

let DaxRatesRaw = { data: [], initialized: false };
let config = { data: [], initialized: false };

async function loadDaxRates() {
  if (!DaxRatesRaw.initialized) {
    let response = await fetch("./60_40_PF.csv");

    let responseText = await response.text();

    let parsedData = Papa.parse(responseText, {
      header: false,
    });

    DaxRatesRaw.data = parsedData.data;
    DaxRatesRaw.initialized = true;
  }
  return DaxRatesRaw.data;
}

async function loadConfig() {
  if (!config.initialized) {
    let response = await fetch("./config.json");
    config.data = await response.json();
    config.initialized = true
  }
  return config.data;
}

export { loadDaxRates, loadConfig };
